import React from "react";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { Footer } from "./Window";
import Icon from "./Icon";
import DisplaySettings from "./DisplaySettings";

// Frame for pages anyone can read without signing in (welcome, guidelines,
// privacy): the site banner, a few links, and the footer.
export default function PublicShell({ children }: { children: React.ReactNode }) {
  const [user] = useAuthState(auth);
  return (
    <div className="site-shell">
      <header className="banner">
        <div className="banner-top">
          <Link to={user ? "/dashboard" : "/welcome"} className="logo">
            <Icon name="mail" size={37} tone="pink" pop className="mr-1" />
            PenPal Board
            <span className="logo-sub">the 2SLGBTQIA+ pen pal network</span>
          </Link>
          <nav className="btn-row" aria-label="Site">
            <DisplaySettings />
            {user ? (
              <Link to="/dashboard" className="btn btn-sm">
                <Icon name="home" size={14} /> Back to the site
              </Link>
            ) : (
              <>
                <Link to="/signin" className="btn btn-plain btn-sm">
                  Sign in
                </Link>
                <Link to="/signup" className="btn btn-sm">
                  Join ✿
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="page-narrow flex flex-col gap-5 !max-w-3xl">{children}</main>
      <Footer />
    </div>
  );
}
